import angular from 'angular'

import component from './scene-pre-loader.component'

export default angular.module('scene-pre-loader', [
])
  .component('scenePreLoader', component)
  .name
